// NEW_FILE_JUSTIFIED: Extract context identity from provider to fix Vite HMR context loss
// src/contexts/globalChatContext.ts
/**
 * Stable context identity for GlobalAIChat.
 * Separated from the provider so Vite HMR can replace provider logic
 * without creating a new context object (which breaks useContext consumers).
 */

import { createContext, useContext } from 'react';
import type { IGlobalChatContextValue } from '@/@types/globalChat';

export const GlobalChatContext = createContext<IGlobalChatContextValue | null>(null);

export function useGlobalChat(): IGlobalChatContextValue {
  const context = useContext(GlobalChatContext);
  if (!context) {
    throw new Error('useGlobalChat must be used within a GlobalAIChatProvider');
  }
  return context;
}
